<template>
  <v-container fluid>
    <v-card class="pa-6">
      <v-row align="center" justify="center">
        <v-card :width="widthcard" class="greenborder" ripple>
          <v-list-item two-line>
            <v-list-item-content align="center" justify="center">
              <div class="text-overline mb-4">
                <v-icon large color="green">
                  mdi-cart
                </v-icon>
              </div>
              <v-list-item-title class="text-h5 mb-1">
                TOTAL {{ this.mDataArray.length }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-card>

        <v-card :width="widthcard" class="redborder ml-10" ripple>
          <v-list-item two-line>
            <v-list-item-content align="center" justify="center">
              <div class="text-overline mb-4">
                <v-icon large color="red">
                  mdi-keyboard-return
                </v-icon>
              </div>
              <v-list-item-title class="text-h5 mb-1">
                RETURN
                <span v-if="this.mDataArray[0]">{{
                  this.mDataArray[0].returnstatus
                }}</span
                ><span v-else>0</span>
              </v-list-item-title>
            </v-list-item-content>

            <!-- <v-list-item-avatar tile size="80" color="#00c0ef">
              <v-icon color="white">mdi-gift-outline </v-icon>
            </v-list-item-avatar> -->
          </v-list-item>
        </v-card>
      </v-row>

      <v-row>
        <v-col cols="12" md="6">
          <v-card-title class="text-h5">Approve TimeSheet</v-card-title>
        </v-col>
        <v-col align="right" color="primary" cols="12" md="6"> </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="6">
          <v-text-field
            class="widthsizesearch"
            v-model="search"
            append-icon="mdi-magnify"
            :label="setlanguage.labelsearch"
            single-line
            hide-details
            outlined
            dense
            @keyup.enter="finddatafromdate"
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="6" class="d-flex justify-end mb-6">
          <v-btn class="mr-2" @click="showsearchmore">
            {{ setlanguage.adddata }}
            <v-icon right>{{ seticonsearchmore.icon }}</v-icon>
          </v-btn>
        </v-col>
      </v-row>
      <v-row v-show="toggleEnable">
        <v-col cols="12" md="6"> </v-col>
        <v-col cols="12" xl="3" lg="3" md="3">
          <v-menu
            v-model="menu"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="computeddatefromFormatted"
                label="DateFrom"
                append-icon="mdi-calendar"
                readonly
                v-bind="attrs"
                v-on="on"
                outlined
                dense
                clearable
                @click:clear="
                  $nextTick(() => {
                    datefrom = null;
                    dateto = null;
                  })
                "
                @input="finddatafromdate"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="datefrom"
              @input="menu = false"
              @change="finddatafromdate"
            ></v-date-picker>
          </v-menu>
        </v-col>
        <v-col cols="12" xl="3" lg="3" md="3">
          <v-menu
            v-model="menu2"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="computeddateToFormatted"
                label="DateTo"
                append-icon="mdi-calendar"
                readonly
                v-bind="attrs"
                v-on="on"
                outlined
                dense
                clearable
                @click:clear="
                  $nextTick(() => {
                    datefrom = null;
                    dateto = null;
                  })
                "
                @input="finddatafromdate"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="dateto"
              @input="menu2 = false"
              @change="finddatafromdate"
            ></v-date-picker>
          </v-menu>
        </v-col>
      </v-row>

      <br />

      <v-card outlined tile>
        <!-- <v-data-table
          dense
          :search="search"
          :headers="headers"
          :items="mDataArray"
          class="elevation-1   595959"
        >
          <template v-slot:[`item.actions`]="{ item }">
            <v-btn
              depressed
              class="mx-2"
              color="#C8E0FE"
              x-small
              @click="onClicktoaddadvance(item.id)"
            >
              select
            </v-btn>
          </template>
        </v-data-table> -->

        <!-- Pagination Section -->
        <div>
          <v-select
            v-model="itemsPerPage"
            @change="onSearchPagination"
            style="width: 150px"
            :items="item_per_page_list"
            label="Items per page"
            dense
            outlined
            hide-details
          ></v-select>
        </div>
        <div>
          <div class="text-center pt-2">
            <v-pagination
              class="ma-3"
              v-model="page"
              :length="pageCount"
              @input="loadDataByPage"
              total-visible="19"
            ></v-pagination>
          </div>

          <v-data-table
            :headers="headers"
            :items="mDataArray2"
            :server-items-length="totalItems"
            :options.sync="options"
            @update:options="onOptionsUpdate"
            hide-default-footer
            class="elevation-1"
            :loading="tableLoading"
            loading-text="Loading... Please wait"
          >
            <!-- Custom loading slot สำหรับแสดง loading แบบวงกลม -->
            <template v-slot:progress>
              <div class="text-center pa-6">
                <v-progress-circular
                  indeterminate
                  color="primary"
                  size="50"
                  width="8"
                ></v-progress-circular>
                <div class="mt-3 text-subtitle-1 primary--text">
                  กำลังโหลดข้อมูล...
                </div>
              </div>
            </template>

            <template v-slot:[`item.actions`]="{ item }">
              <v-btn
                depressed
                class="mx-2"
                color="#C8E0FE"
                x-small
                @click="onClicktoaddadvance(item.id)"
              >
                select
              </v-btn>
            </template>
          </v-data-table>
        </div>
      </v-card>

      <v-dialog v-model="dialogDelete" max-width="500px">
        <v-card>
          <v-card-title class="text-h5"
            >Are you sure you want to delete this item?</v-card-title
          >
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="closeDelete"
              >Cancel</v-btn
            >
            <v-btn color="blue darken-1" text @click="deleteItemConfirm"
              >OK</v-btn
            >
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-card>
  </v-container>
</template>

<script>
import SuccessDialog from "@/components/cards/SuccessDialog";
import api from "@/services/api";
import { server } from "@/services/constants";
import { language } from "./language/Advancelist.js";
import unity from "@/unity/unity";

export default {
  name: "approve-advance-list",
  data(vm) {
    return {
      tableLoading: false,

      item_per_page_list: [10, 20, 100, 200, 500, 1000],
      options: {
        page: 1,
        itemsPerPage: 10,
        sortBy: [],
        sortDesc: [],
      },
      // Pagination
      page: 1,
      pageCount: 0,
      itemsPerPage: 10,
      totalItems: 0,
      dataAll2: [],
      mDataArray2: [],

      menu: false,
      menu2: false,
      search: "",
      toggleEnable: false,
      selectstatus: "",
      dataAll: [],
      status: ["Draft", "Request", "Approve", "Reject", "Cancel", "Paid"],
      datefrom: null,
      dateto: null,
      dateCurrent: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      seticonsearchmore: { icon: "mdi mdi-chevron-down", action: false },
      setlanguage: language.en,
      defaultlanguage: "en",
      // regexlang: "th",
      chooselanguage: [
        { name: "en", flag: "gb" },
        { name: "th", flag: "th" },
      ],
      aa: "สวัสดี",
      dialogEdit: false,
      dialogDelete: false,
      mDataArray: [],
      position: [],
      approver: [],
      department: [],
      department_list: [],
      position_list: [],
      company: [],
      authorize: [],
      // mDataArray: [
      //   {
      //     no: 1,
      //     date: "1/11/2022",
      //     name: "testname",
      //     customer: "ABS co Ltd",
      //     amount: "10,000",
      //     status: "Unapproved",
      //   },
      //   {
      //     no: 2,
      //     date: "2/11/2022",
      //     name: "testname2",
      //     customer: "ABS co Ltd",
      //     amount: "3,000",
      //     status: "Approved",
      //   },
      // ],
      headers: [
        {
          text: "TimeSheet No.",
          value: "timesheet_id",
          class: "bg-colorth tabletextwhite",
        },
        {
          text: "Requested Date",
          value: "date",
          class: "bg-colorth tabletextwhite",
        },
        {
          text: "Employee Name",
          value: "name",
          class: "bg-colorth tabletextwhite",
        },
        {
          text: "TimeSheet Name",
          value: "timesheet_name",
          class: "bg-colorth tabletextwhite",
        },

        {
          text: "",
          value: "actions",
          class: "bg-colorth tabletextwhite",
        },
        // {
        //     text: "Actions",
        //     value: "actions",
        //     sortable: false
        // },
      ],
    };
  },
  async beforeCreate() {
    console.log("beforeCreate");
    this.$store.state.navMenu = true;
  },
  async created() {
    // this.headers = language.en.headertable;
    // this.initialize();
  },
  beforeUpdate() {},
  computed: {
    computeddatefromFormatted() {
      return unity.formatDate(this.datefrom);
    },
    computeddateToFormatted() {
      return unity.formatDate(this.dateto);
    },
    itemsForSelected() {
      if (this.search.length) {
        return this.dataSource.filter((item) => this.search.includes(item));
      }
      return this.dataSource;
    },
    widthcard() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return "35%";
        case "sm":
          return "30%";
        case "md":
          return "30%";
        case "lg":
          return "20%";
        case "xl":
          return "20%";
      }
    },
  },
  async mounted() {
    await api.checkVersion();
    this.userId = localStorage.getItem(server.USER_ID);
    let yourUrlString = window.location;
    // alert(yourUrlString);

    let parser = document.createElement("a");
    parser.href = yourUrlString;

    this.authorize_id = localStorage.getItem(server.AUTHORIZE_ID);

    // alert("authorize_id:" + this.authorize_id);
    if (this.authorize_id == null || this.authorize_id == 0) {
      // this.$router.push("/login");
      this.$store.state.global_dialog = true;
      this.setupAlertDialog(
        true,
        "Authorize Failed",
        "Please Logout And Login Again",
        "text-h5 red--text text-center"
      );
      this.$router.back();
    }

    const router_path = parser.pathname.replace("/", "");

    const res_auth = await api.getAuthorize(this.userId, router_path);

    // console.log("res_auth:" + JSON.stringify(res_auth.data));

    this.authorize_view = res_auth.data[0].smd_view >= 1 ? true : false;
    this.authorize_add = res_auth.data[0].smd_add >= 1 ? true : false;
    this.authorize_edit = res_auth.data[0].smd_edit >= 1 ? true : false;
    this.authorize_del = res_auth.data[0].smd_del >= 1 ? true : false;

    // console.log("res_auth:" + JSON.stringify(res_auth.data));
    // console.log("authorize_view:" + this.authorize_view);
    // console.log("authorize_add:" + this.authorize_add);
    // console.log("authorize_edit:" + this.authorize_edit);
    // console.log("authorize_del:" + this.authorize_del);
    // this.$router.back();

    if (!this.authorize_view) {
      this.$router.push("/not-found");
    }

    // ----------------- Check Authorize ---------------------------

    let comp_id = localStorage.getItem(server.COMPANYID);
    // await this.loadCompanyMaster(comp_id);
    // await this.loadDepartmentMaster(comp_id);
    // await this.loadPositionMaster(comp_id);

    await this.loadAuthorize();
    // await this.loaddataapproveAdvance();

    this.userId = localStorage.getItem(server.USER_ID);
    if (this.userId && api.isLoggedIn()) {
      // this.$router.push("/");
    } else {
      this.$store.state.isLogged = false;
      this.$router.push("/login");
    }

    this.$hideLoader();
  },
  methods: {
    // 3. แก้ไขฟังก์ชัน loaddataPagination
    async loaddataPagination() {
      console.log("loaddataPagination");

      var tmp = [];
      this.dataAll2 = [];
      this.mDataArray2 = [];
      this.tableLoading = true;

      /*
        page,
        limit,
        sortBy,
        sortOrder,
        company_id,
        department_id
     */

      try {
        const result = await api.approvergettimesheetHbyCompanyPagination(
          1,
          this.itemsPerPage,
          "id",
          "ASC",
          localStorage.getItem(server.USER_ID),
          localStorage.getItem(server.COMPANYID)
        );

        console.log(`loaddataPagination result: ${JSON.stringify(result)}`);

        this.dataAll2 = result.data.data;
        this.dataAll2.forEach((x, index) => {
          // x.amount = tolocalestringnumber(x.amount);

          x.status_id = x.status;
          if (x.status == 1) {
            x.status = "Draft";
          } else if (x.status == 2) {
            x.status = "Request";
          } else if (x.status == 3) {
            x.status = "Approve";
          } else if (x.status == 4) {
            x.status = "Reject";
          }
        });
        this.mDataArray2 = this.dataAll2;

        this.totalItems = result.data.pagination.totalRecords;
        this.page = result.data.pagination.currentPage;
        this.itemsPerPage = result.data.pagination.recordsPerPage;
        this.pageCount = result.data.pagination.totalPages;
      } catch (error) {
        console.error("Error loading data:", error);
      } finally {
        this.tableLoading = false;
      }
    },

    // 4. แก้ไขฟังก์ชัน onOptionsUpdate
    async onOptionsUpdate(options) {
      console.log("onOptionsUpdate:", options);

      this.tableLoading = true;
      let tmp = [];
      this.dataAll2 = [];
      this.mDataArray2 = [];
      let sortDesc = "";
      if (options.sortDesc[0] == true) {
        sortDesc = "DESC";
      } else {
        sortDesc = "ASC";
      }

      /*
        page,
        limit,
        sortBy,
        sortOrder,
        company_id,
        department_id
     */

      try {
        const result = await api.approvergettimesheetHbyCompanyPagination(
          options.page,
          this.itemsPerPage,
          options.sortBy[0],
          sortDesc,
          localStorage.getItem(server.USER_ID),
          localStorage.getItem(server.COMPANYID)
        );
        // console.log(`onOptionsUpdate result: ${JSON.stringify(result)}`);

        this.dataAll2 = result.data.data;
        this.dataAll2.forEach((x, index) => {
          // x.amount = tolocalestringnumber(x.amount);

          x.status_id = x.status;
          if (x.status == 1) {
            x.status = "Draft";
          } else if (x.status == 2) {
            x.status = "Request";
          } else if (x.status == 3) {
            x.status = "Approve";
          } else if (x.status == 4) {
            x.status = "Reject";
          }
        });
        this.mDataArray2 = this.dataAll2;

        this.totalItems = result.data.pagination.totalRecords;
        this.page = result.data.pagination.currentPage;
        this.itemsPerPage = result.data.pagination.recordsPerPage;
        this.pageCount = result.data.pagination.totalPages;
      } catch (error) {
        console.error("Error updating options:", error);
      } finally {
        this.tableLoading = false;
      }
    },

    // 5. แก้ไขฟังก์ชัน loadDataByPage
    async loadDataByPage(pageNumber) {
      console.log("loadDataByPage:", pageNumber);

      this.tableLoading = true;
      let tmp = [];
      this.dataAll2 = [];
      this.mDataArray2 = [];

      /*
          page,
        limit,
        sortBy,
        sortOrder,
        company_id,
        department_id
     */

      try {
        const result = await api.approvergettimesheetHbyCompanyPagination(
          pageNumber,
          this.itemsPerPage,
          "id",
          "ASC",
          localStorage.getItem(server.USER_ID),
          localStorage.getItem(server.COMPANYID)
        );

        console.log(`loadDataByPage result: ${JSON.stringify(result)}`);

        this.dataAll2 = result.data.data;
        this.dataAll2.forEach((x, index) => {
          // x.amount = tolocalestringnumber(x.amount);

          x.status_id = x.status;
          if (x.status == 1) {
            x.status = "Draft";
          } else if (x.status == 2) {
            x.status = "Request";
          } else if (x.status == 3) {
            x.status = "Approve";
          } else if (x.status == 4) {
            x.status = "Reject";
          }
        });
        this.mDataArray2 = this.dataAll2;

        this.totalItems = result.data.pagination.totalRecords;
        this.page = result.data.pagination.currentPage;
        this.itemsPerPage = result.data.pagination.recordsPerPage;
        this.pageCount = result.data.pagination.totalPages;
      } catch (error) {
        console.error("Error loading page data:", error);
      } finally {
        this.tableLoading = false;
      }
    },

    // 6. แก้ไขฟังก์ชัน onSearchPagination
    async onSearchPagination() {
      console.log("onSearchPagination:", this.itemsPerPage);
      this.mDataArray2 = [];
      let tmp = [];
      this.dataAll2 = [];
      this.mDataArray2 = [];
      this.page = 1;
      this.tableLoading = true;

      /*
        page,
        limit,
        sortBy,
        sortOrder,
        company_id,
        department_id
     */

      try {
        const result = await api.approvergettimesheetHbyCompanyPagination(
          1,
          this.itemsPerPage,
          "id",
          "ASC",
          localStorage.getItem(server.USER_ID),
          localStorage.getItem(server.COMPANYID)
        );

        console.log(`onSearchPagination result: ${JSON.stringify(result)}`);

        this.dataAll2 = result.data.data;
        this.dataAll2.forEach((x, index) => {
          // x.amount = tolocalestringnumber(x.amount);

          x.status_id = x.status;
          if (x.status == 1) {
            x.status = "Draft";
          } else if (x.status == 2) {
            x.status = "Request";
          } else if (x.status == 3) {
            x.status = "Approve";
          } else if (x.status == 4) {
            x.status = "Reject";
          }
        });
        this.mDataArray2 = this.dataAll2;

        this.totalItems = result.data.pagination.totalRecords;
        this.page = result.data.pagination.currentPage;
        this.itemsPerPage = result.data.pagination.recordsPerPage;
        this.pageCount = result.data.pagination.totalPages;
      } catch (error) {
        console.error("Error searching data:", error);
      } finally {
        this.tableLoading = false;
      }
    },

    editItem() {},
    changelange: function(newVal, oldVal) {
      if (this.defaultlanguage === "en") {
        console.log(language.en.headertable);
        this.headers = language.en.headertable;

        // this.headers[0].text = language.en.headertable.no;

        this.setlanguage = Object.assign({}, language.en);
      } else {
        this.headers = language.th.headertable;
        this.setlanguage = Object.assign({}, language.th);
      }
    },
    showsearchmore() {
      this.toggleEnable = !this.toggleEnable;
      this.seticonsearchmore.action = !this.seticonsearchmore.action;
      if (this.seticonsearchmore.action === true) {
        this.seticonsearchmore.icon = "mdi mdi-chevron-up";
      } else {
        this.seticonsearchmore.icon = "mdi mdi-chevron-down";
      }
    },
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${year}-${month - 1}-${day}`;
    },
    finddatafromdate() {
      console.log(`Searching for: ${this.search}`);
      this.mDataArray2 = this.dataAll2.filter((item) => {
        if (this.datefrom != null && this.dateto != null) {
          if (
            unity.parseDate(item.date) >= this.datefrom &&
            unity.parseDate(item.date) <= this.dateto
          ) {
            return item;
          }
        }
        // if (this.datefrom == null && this.dateto == null) {
        //   return item;
        // }

        // เพิ่มการค้นหาด้วย search text
        if (this.search != "" && this.search != null) {
          console.log(`Searching IF: ${this.search}`);
          const searchLower = this.search.toLowerCase();
          if (
            item.timesheet_id
              .toString()
              .toLowerCase()
              .includes(searchLower) ||
            item.name.toLowerCase().includes(searchLower) ||
            item.timesheet_name.toLowerCase().includes(searchLower) ||
            item.date.toLowerCase().includes(searchLower)
          ) {
            return item;
          }
        }
      });
    },
    onClicktoaddadvance(id) {
      this.$router.push(`/edit-approvetimesheet/${id}`);
    },
    async loadCompanyMaster(id) {
      const result = await api.getCompanyMaster(id);
      this.company = result.data;
    },

    async loadDepartmentMaster(id) {
      const result = await api.getDepartmentMaster(id);
      // console.log("result.data : ", JSON.stringify(result.data));
      this.department = result.data;
      // console.log('test dapart')
      // console.log(this.department)
      result.data.forEach((item) => {
        this.department_list.push(item.name);
      });
    },
    async loadAuthorize() {
      const res_get = await api.getSettingGroupMenu();
      // console.log("res loadAuthorize : ", JSON.stringify(res_get));
      this.authorize = res_get.data;
    },

    async loadPositionMaster(id) {
      const result = await api.getPositionMaster(id);
      // console.log("result.data : ", JSON.stringify(result.data));
      this.position = result.data;

      result.data.forEach((item) => {
        this.position_list.push(item.name);
      });
    },

    async loadDetailAccount(id) {
      // console.log("loadDetailAccount:", id + "//");
      const result = await api.getAccountDetail(id);
      // console.log("loadDetailAccount result: ", JSON.stringify(result));
      this.editedItem = Object.assign({}, result.data[0]);
    },
    async loaddataapproveAdvance() {
      const result = await api.approvergettimesheetHbyCompany(
        localStorage.getItem(server.USER_ID),
        localStorage.getItem(server.COMPANYID)
      );
      console.log(result);
      this.dataAll2 = result.data;
      console.log(this.dataAll2);
      this.dataAll2.forEach((x, index) => {
        x.status_id = x.status;
        if (x.status == 1) {
          x.status = "Draft";
        } else if (x.status == 2) {
          x.status = "Request";
        } else if (x.status == 3) {
          x.status = "Approve";
        } else if (x.status == 4) {
          x.status = "Reject";
        }
      });
      this.mDataArray2 = this.dataAll2;

      // //console.log(this.approver)
      // result.data.forEach((item) => {
      //   this.approver.push(item.firstname);
      // });

      // this.$showLoader();
      this.$hideLoader();
    },
  },
};
</script>

<style scoped>
.bg-colorth {
  background-color: #595959;
  color: red;
}
.text-left {
  color: aliceblue;
}
.widthsizesearch {
  width: 70%;
}
.greenborder {
  border: 4px solid green;
}
.theme--light.v-card.greenborder {
  border-color: green;
}
.theme--light.v-card.redborder {
  border-color: red;
}
.redborder {
  border: 4px solid red;
}
/* .theme--light.v-card {
  border-color: white;
} */
</style>
